import Req from '../../req'
const actions = {
    readguideget: function (store, [cb]) {
        let data = {
            uid: store.rootState.user.uid,
            token: store.rootState.user.owcode,
            product: 2581
        }
        Req.speed.readguideget(data, cb);
    },
    readguideset: function (store, [cb]) {
        let data = {
            uid: store.rootState.user.uid,
            token: store.rootState.user.owcode,
            product: 2581
        }
        Req.speed.readguideset(data, cb);
    },
    limitget: function (store, [peerid, cb]) {
        let data = {
            uid: store.rootState.user.uid,
            token: store.rootState.user.owcode,
            pid: peerid,
            product: 2581
        }
        Req.speed.limitget(data, cb);
    },
    limitset: function (store, [peerid, diskcache, upLoadSpeed, openOrCloseFlag, share_switch, cb]) {
        let data = {
            uid: store.rootState.user.uid,
            token: store.rootState.user.owcode,
            pid: peerid,
            product: 2581,
        }
        if (diskcache) {
            data.diskcache = diskcache;
        }
        if (upLoadSpeed) {
            data.upLoadSpeed = upLoadSpeed;
        }
        if (openOrCloseFlag !== null) {
            data.switch = openOrCloseFlag;
        }
        if (share_switch) {
            data.share_switch = share_switch;
        }
        Req.speed.limitset(data, cb);
    },
    cacheclean: function (store, [peerid, percent, cb]) {
        let data = {
            uid: store.rootState.user.uid,
            token: store.rootState.user.owcode,
            pid: peerid,
            product: 2581,
            clean: 1,
            percent: percent
        }

        Req.speed.cacheclean(data, cb);
    },
}
export default {
    namespaced: false,
    actions
}